// AvatarSelection.jsx
import React, { useState, useEffect, useRef} from "react";
import { useNavigate } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {
  PageContainer,
  Title,
  Description,
  AvatarContainer,
  AvatarImage,
  NextButton,
  CarouselContainer,
  AvatarDiv,
} from "./style";
import { AVATARS } from "../../Components/Constants/Constants";

const AvatarSelection = () => {
  const [selectedAvatar, setSelectedAvatar] = useState(1);
  const navigate = useNavigate();
  const carouselRef = useRef();
  
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  useEffect(() => {
    const fetchAvatar = async () => {
      try {
        const userId = localStorage.getItem('id');
        const response = await fetch(`https://api.aiflowpro.io/api/auth/get-avatar?user_id=${userId}`);
        const data = await response.json();
  
        if (data.responseCode === 200 && data.avatar?.imageId) {
          const avatarIndex = AVATARS.findIndex(avatar => avatar.imageId === data.avatar.imageId);
          const finalIndex = avatarIndex !== -1 ? avatarIndex : 1;
          setSelectedAvatar(finalIndex);
          
          // Programmatically go to the selected avatar slide
          if (carouselRef.current) {
            carouselRef.current.goToSlide(finalIndex - 3);
          }
        }
      } catch (error) {
        console.error('Error fetching avatar:', error);
        setSelectedAvatar(1);
      }
    };
  
    fetchAvatar();
  }, []);

  const handleAvatarClick = (index) => {
    setSelectedAvatar(index);
  };

  const handleNextClick = () => {
    const selectedImageId = AVATARS[selectedAvatar].imageId;
    navigate("/avatar-info", { state: { imageId: selectedImageId } });
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <PageContainer>
      <AvatarDiv>
        <Title>Select Avatar</Title>
        <Description>
          "Choose your AI assistant and watch it work wonders for you! 🚀"
        </Description>
        <CarouselContainer>
          <Carousel
            ref={carouselRef} // Attach the ref here
            responsive={responsive}
            infinite={true}
            centerMode={true}
            keyBoardControl={true}
            customTransition="transform 300ms ease-in-out"
            containerClass="carousel-container"
            dotListClass="carousel-dots"
            itemClass="carousel-item"
          >
            {AVATARS?.slice(0, 8).map((avatar, index) => (
              <AvatarContainer
                key={index}
                onClick={() => handleAvatarClick(index)}
                isSelected={selectedAvatar === index}
              >
                <AvatarImage src={avatar.src} alt={avatar.alt} />
              </AvatarContainer>
            ))}
          </Carousel>
        </CarouselContainer>
        <div style={{ display: "flex" }}>
          <NextButton style={{ background: "none", color: "#313133" }} onClick={handleBackClick}>Back</NextButton>
          <NextButton onClick={handleNextClick}>Next</NextButton>
        </div>
      </AvatarDiv>
    </PageContainer>
  );
};

export default AvatarSelection;
